import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { Autocomplete } from 'Components/ui';

const INK = 'var(--vo-ink)';
const MUTED = 'var(--vo-slate)';
const TEXT = 'var(--vo-ink-2)';

const Card = styled.div`
  max-width: 800px;
  background: white;
  border-radius: 14px;
  padding: 28px;
  box-shadow: 0 1px 3px var(--vo-escuro-8);
`;

const BondTitle = styled.p`
  font-family: 'Rubik', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: ${INK};
  margin: 0 0 4px;
`;

const BondSubtitle = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  color: ${MUTED};
  margin: 0 0 24px;
`;

const FieldsStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Label = styled.label`
  font-family: 'Maven Pro', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: ${TEXT};
`;

const isSameRecord = (option, val) => option._id === val._id;

export const Vinculos = ({ control, areas, processes, assets, areaLoading, processLoading, assetLoading, t }) => {
  return (
    <Card>
      <BondTitle>{t('mapping:systems.form.bondsSectionTitle')}</BondTitle>
      <BondSubtitle>{t('mapping:systems.form.bondsSectionSubtitle')}</BondSubtitle>

      <FieldsStack>
        <FieldGroup>
          <Label>{t('mapping:systems.form.bonds.areas')}</Label>
          <Controller
            control={control}
            name="areas"
            render={({ field: { onChange, value } }) => (
              <Autocomplete
                multiple
                filterSelectedOptions
                isOptionEqualToValue={isSameRecord}
                options={(areas || []).filter(item => !item.archived)}
                getOptionLabel={(item) => item.name}
                value={value || []}
                onChange={onChange}
                loading={areaLoading}
                disabled={areaLoading}
                placeholder={t('mapping:systems.form.bonds.searchArea')}
              />
            )}
          />
        </FieldGroup>
        <FieldGroup>
          <Label>{t('mapping:systems.form.bonds.processes')}</Label>
          <Controller
            control={control}
            name="processes"
            render={({ field: { onChange, value } }) => (
              <Autocomplete
                multiple
                filterSelectedOptions
                isOptionEqualToValue={isSameRecord}
                options={(processes || []).filter(item => !item.archived)}
                getOptionLabel={(item) => item.name}
                value={value || []}
                onChange={onChange}
                loading={processLoading}
                disabled={processLoading}
                placeholder={t('mapping:systems.form.bonds.searchProcess')}
              />
            )}
          />
        </FieldGroup>
        <FieldGroup>
          <Label>{t('mapping:systems.form.bonds.assets')}</Label>
          <Controller
            control={control}
            name="assets"
            render={({ field: { onChange, value } }) => (
              <Autocomplete
                multiple
                filterSelectedOptions
                isOptionEqualToValue={isSameRecord}
                options={(assets || []).filter(item => !item.archived)}
                getOptionLabel={(item) => item.name}
                value={value || []}
                onChange={onChange}
                loading={assetLoading}
                disabled={assetLoading}
                placeholder={t('mapping:systems.form.bonds.searchAsset')}
              />
            )}
          />
        </FieldGroup>
      </FieldsStack>
    </Card>
  );
};
